import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: var(--text);
`;

const OrderCancel = () => {
  return (
    <Page>
      <h2 style={{ color: 'var(--accent)' }}>Payment Canceled</h2>
      <p>Your payment was canceled or failed. You can try again.</p>
      <p>
        Return to your <Link to="/cart">Cart</Link> or browse the <Link to="/products">Products</Link>.
      </p>
    </Page>
  );
};

export default OrderCancel;
